module.exports = __webpack_public_path__ + "static/img/member03.93d41198.png";